import { createContext, useEffect, useState } from "react";
import FullScreenLoader from "../../components/ui/loaders/FullScreenLoader";

export const LoaderContext = createContext(null);

export const FullScreenLoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [loaderText, setLoaderText] = useState("");

  // Prevent background scroll when loader is active
  useEffect(() => {
    if (loading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [loading]);

  const showLoader = (text) => {
    if (text) setLoaderText(text);
    setLoading(true);
  };

  const hideLoader = () => {
    setLoading(false);
    setLoaderText("");
  };

  return (
    <LoaderContext.Provider
      value={{
        loading,
        showFullScreenLoader: showLoader,
        hideFullScreenLoader: hideLoader,
      }}
    >
      {children}
      {loading && <FullScreenLoader text={loaderText} />}
    </LoaderContext.Provider>
  );
};
